export default __webpack_public_path__ + "8cf6af08a8a9780bd8ab0a94d3c8227c.png";